<template>
  <nav class="sidenav-new">
    <el-menu
      :default-active="active"
      :unique-opened="true"
      :default-openeds="opened"
      :collapse="bodyWidth < 1280"
    >
      <div v-for="(menu, idx) in menus" :key="idx">
        <div v-if="menu.children">
          <el-submenu :index="`${menu.id}`" v-if="!checkSCM(menu)">
            <template slot="title">
              <i :class="`iconfont ${menu.icon}`"></i>
              <el-badge is-dot class="item px-badge" v-if="menu.hasNewPoint === true">
                <span class="menu-name">{{menu.name}}</span>
              </el-badge>
              <span v-else class="menu-name">{{menu.name}}</span>
            </template>
            <template  v-for="(child, idx) in menu.children">
              <div :key="idx"
                v-if="(checkMenuAuthority(child))"
                :class="child.className ? child.className : null"
              >
                <el-menu-item
                  :index="`${child.id}`"
                  v-if="(child.path && child.path !== '/Member/MemberTransfer') || (child.path === '/Member/MemberTransfer' && !crmUpdateClose)"
                  @click="jump(child, menu)"
                >
                  <el-badge value="NEW" class="item px-badge" v-if="child.hasNewPoint">
                    {{child.name}}
                  </el-badge>
                  <span v-else>{{child.name}}</span>
                </el-menu-item>
                <a :href="ctx+getMenuPath(child.oldPath)" v-else-if="child.oldPath">
                  <el-menu-item :index="child.id">{{child.name}}</el-menu-item>
                </a>
              </div>
            </template>
          </el-submenu>
        </div>
        <div v-else>
          <router-link :to="menu.path" v-if="menu.path">
            <el-menu-item :index="`${menu.id}`">
              <i :class="`iconfont ${menu.icon}`"></i>
              <span slot="title" class="menu-name">{{menu.name}}</span>
            </el-menu-item>
          </router-link>
          <a :href="ctx+getMenuPath(menu.oldPath)" v-else>
            <el-menu-item :index="menu.id">
              <i :class="'iconfont '+menu.icon"></i>
              {{menu.name}}
            </el-menu-item>
          </a>
        </div>
      </div>
    </el-menu>
  </nav>
</template>

<script>
  import {mapState} from 'vuex';
  import getMenuPath from "@util/getMenuPath";
  import getRouterConf from '@util/getRouterConf';
  import ignoreMenus from '@constants/ignoreMenu';
  import isCRMUser from '@util/isCRMUser';
  import { hasType } from '@util/checkAgencyType';
  import {getCookie} from '@util/cookie';

  export default {
    props: ['menus'],
    data () {
      return {
        ctx: isCRMUser() ? '/hq-web/indexnew#' : '/hq-web/index#',
        active: null,
        opened: [],
        permissionList: [],
        bodyWidth: document.body.clientWidth
      };
    },
    computed: {
      ...mapState(['crmUpdateClose'])
    },
    created () {
      let permissionList = localStorage.getItem('menuList');
      if (permissionList === null) {
        this.$axios.get('/hq-agency/user/menu').then((res) => {
          const menus = res.data;
          localStorage.setItem('menu', JSON.stringify(menus));
          const menuList = {};
          for (let i = 0; i < menus.length; i++) {
            const sysCode = menus[i].systemCode;
            const menu = menus[i].menu;
            const idList = [];
            for (let i = 0; i < menu.length; i++) {
              idList.push(menu[i].id);
            }
            menuList[sysCode] = idList;
          }
          localStorage.setItem('menuList', JSON.stringify(menuList));
          this.permissionList = menuList.chain || [];
        });
      } else {
        this.permissionList = JSON.parse(localStorage.getItem('menuList')).chain || [];
      }
      this.checkBodyWidth();
      this.handleRouteChange();
    },
    watch: {
      '$route': function () {
        this.handleRouteChange();
      }
    },
    methods: {
      getMenuPath: getMenuPath,
      handleRouteChange () {
        if (this.$route.path !== '/Midware') {
          let checkPermission = true;
          ignoreMenus.forEach(ignoreMenu => {
            if (this.$route.path === ignoreMenu) {
              checkPermission = false;
            }
          });
          if (checkPermission) {
            const config = getRouterConf(this.$route.path);
            if (config[1] && config[1].id) {
              this.active = config[1].id.toString();
              this.opened = this.bodyWidth < 1280 ? [] : [config[0].id.toString()];
            }
          }
        }
      },
      checkSCM (item) {
        if (item.id === '190' && this.permissionList.indexOf(window.parseInt(item.id)) === -1) {
          return true;
        } else if (hasType('SCM') && (item.id === '70' || item.id === '80' || (item.id === '190' && !getCookie('pingxin_fe_show_history_menu')))) {
          return true;
        } else if (hasType('NEW_CRM') && (item.id === '2000000050' || item.id === '2000000120')) {
          return true;
        } else if (hasType('SCM_DC') && (item.id === '70' || item.id === '80' || (item.id === '190' && !getCookie('pingxin_fe_show_history_menu')))) {
          return true;
        } else if (item.id === '9600' && !getCookie('pingxin_fe_service_center')) {
          return true;
        } else {
          return false;
        }
      },
      checkMenuAuthority (item) {
        if (item.id === '1' || item.id === '14010' ) {
          return true;
        }
        if (getCookie('pingxin_fe_service_center') && item.id.indexOf('960') >= 0) {
          return true;
        }
        // 一键迁移： 通过parseInt转化为数字，通过判断其父权限来展示
        let flag = false;
        flag = `${item.sign || [item.id]}`.split('_').some((i) => {
          return this.permissionList.indexOf(window.parseInt(i)) >= 0;
        });
        return flag;
      },
      checkBodyWidth () {
        let _this = this;
        window.onresize = function () {
          _this.bodyWidth = document.body.clientWidth;
          _this.opened = _this.bodyWidth < 1280 ? [] : _this.opened;
        };
      },
      jump (child, menu) {
        const LXAnalytics = window.LXAnalytics || function () {
          // do nothing
        };
        if (child.id === '9601') {
          //this.handleRouteChange();
          LXAnalytics('moduleClick', 'b_eco_pbtt2gna_mc', {}, { cid: 'c_eco_m81yc73q' });
          window.open(child.path);
          window.location.reload();
          return;
        } else if (child.id === '9602') {
          let curSsid = getCookie('SSID');
          LXAnalytics('moduleClick', 'b_eco_m9vg606j_mc', {}, { cid: 'c_eco_m81yc73q' });
          window.open(`${child.path}?ssid=${curSsid}`);
          window.location.reload();
          
        } else if (child.id === '9603') {
          LXAnalytics('moduleClick', 'b_eco_fd8xztbp_mc', {}, { cid: 'c_eco_m81yc73q' });
        }
        let path = child.path;
        if (this.$route.path === path || this.$route.path === path + '/') {
          // 转到中间件来强制刷新当前 router-view
          this.$router.replace({
            path: '/Midware',
            query: {
              targetUrl: path
            }
          });
        } else {
          this.navigateTo({
            path: path
          });
          _hmt.push(['_trackEvent', 'click_subMenu', child.name, menu.name]);
        }
      }
    },
  };
</script>

<style lang="less">
  nav.sidenav-new {
    width: 200px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    .el-menu {
      border-right: 0 none;
    }
  }
</style>



// WEBPACK FOOTER //
// SideNavCRM.vue?c70e47bc